// extracted by mini-css-extract-plugin
module.exports = {"Time":"Timer-module__Time___14vP3","time":"Timer-module__Time___14vP3"};